<mat-tab-group class="mat-tab-group-principal" (selectedTabChange)="onTabChange($event)">
  <mat-tab label="{{ 'calibrateEquipmentEdit.calibrationData.title' | translate }}">

    <form>

      <mat-card class="card">
        <mat-card-content>
          <mat-toolbar color="secondary">
            {{ 'calibrateEquipmentEdit.calibrationData.title' | translate }}
          </mat-toolbar>

          <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

            <div fxFlex="33" fxFlex.lt-md="100%">
              <div fxLayout="column" class="flexwrap">

                @if (calibration.id == null) {
                <div fxFlex>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'calibrateEquipmentList.filter.client.label' | translate }}</mat-label>
                    <mat-select #clientSelect name="idClientSelected" [(ngModel)]="idClientSelected"
                      (optionSelected)="onClientChange($event)">
                      @if (clientSelect.focused) {
                      <mat-select-filter [displayMember]="'name'" [array]="clients"
                        (filteredReturn)="clientsFiltered =$event" [noResultsMessage]="'common.noResults' | translate"
                        [placeholder]="'common.selectFilterPlaceholder' | translate"></mat-select-filter>
                      }
                      <mat-option value="-1"> -- {{ 'calibrationResponsibleType.internal' | translate | uppercase }} --
                      </mat-option>
                      @for (client of clientsFiltered; track client) {
                      <mat-option [value]="client.id">
                        {{client.name}}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                }

                @if (calibration.id == null && idClientSelected != null) {
                <div fxFlex>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.equipment.label' | translate }}</mat-label>
                    <input matInput [ngModel]="equipment.name" #trigger="matAutocompleteTrigger"
                      [matAutocomplete]="auto" (keyup)="lookupEquipment($event)" [ngModelOptions]="{standalone: true}">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn"
                      (optionSelected)="onSensorChange($event, trigger)">
                      @for (item of equipmentAutoComplete; track item; let index = $index) {
                      <mat-option [value]="item">
                        {{ item.name}} ({{item.serialNum}})
                      </mat-option>
                      }
                    </mat-autocomplete>
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.patterns.dialog.equipment.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
                }

                @if (calibration.id == null && idClientSelected != null) {
                <div fxFlex>
                  <a class="under-card-link" style="cursor: pointer;margin: inherit;" (click)="createEquipment()">
                    {{ 'calibrateEquipmentEdit.general.equipment.notExists' | translate }}
                  </a>
                </div>
                }

                @if (calibration.id != null) {
                <div fxFlex>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.name.label' | translate }}</mat-label>
                    <input matInput name="name" [(ngModel)]="equipment.name" disabled>
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.general.name.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
                }

                @if (equipment.id != null) {
                <div fxFlex>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.equipment.label' | translate }}</mat-label>
                    <input matInput name="equipment" [(ngModel)]="equipment.equipment" disabled>
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.general.equipment.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
                }

                @if (equipment.id != null) {
                <div fxFlex>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.maker.label' | translate }}</mat-label>
                    <input matInput name="maker" [(ngModel)]="equipment.maker" disabled>
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.general.maker.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
                }

                @if (equipment.id != null) {
                <div fxFlex>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.model.label' | translate }}</mat-label>
                    <input matInput name="model" [(ngModel)]="equipment.model" disabled>
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.general.model.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
                }

                @if (equipment.id != null) {
                <div fxFlex>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.serialNum.label' | translate }}</mat-label>
                    <input matInput name="serialNum" [(ngModel)]="equipment.serialNum" disabled>
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.general.serialNum.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
                }

              </div>
            </div>

            <div fxFlex="33" fxFlex.lt-md="100%">

              <div fxLayout="column" class="flexwrap">

                <div fxFlex>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.certificateNum.label' | translate }}</mat-label>
                    <input matInput name="certificateNum" [(ngModel)]="calibration.certificateNum"
                      [disabled]="isEditable()">
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.general.certificateNum.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex>
                  <mat-form-field style="width: 95%;">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.calibrateDate.label' | translate }}</mat-label>
                    <input matInput [matDatepicker]="calibrateDate" name="calibrationDate"
                      [ngModel]="calibration.calibrationDate" (blur)="saveDate('calibrationDate', $event)"
                      (dateChange)="saveDate('calibrationDate', $event)" [disabled]="isEditable()"
                      [max]="maxDateCalibration">
                    <mat-datepicker-toggle matSuffix [for]="calibrateDate"></mat-datepicker-toggle>
                    <mat-datepicker #calibrateDate>
                    </mat-datepicker>
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.general.calibrateDate.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex>
                  <mat-form-field style="width: 95%;">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.expirationDate.label' | translate }}</mat-label>
                    <input matInput [matDatepicker]="expirationDate" name="expirationDate"
                      [ngModel]="calibration.expirationDate" (blur)="saveDate('expirationDate', $event)"
                      (dateChange)="saveDate('expirationDate', $event)" [disabled]="isEditable()">
                    <mat-datepicker-toggle matSuffix [for]="expirationDate"></mat-datepicker-toggle>
                    <mat-datepicker #expirationDate>
                    </mat-datepicker>
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.general.expirationDate.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                @if (calibration.id != null) {
                <div fxFlex>
                  <mat-checkbox name="showExpirationDate" [(ngModel)]="calibration.showExpirationDate">
                    {{'calibrateEquipmentEdit.general.showExpirationDate.label' | translate }}
                  </mat-checkbox>
                </div>
                }

                <div fxFlex>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.projectNumber.label' | translate }}</mat-label>
                    <input matInput name="projectNo" [(ngModel)]="calibration.projectNo" [disabled]="isEditable()">
                  </mat-form-field>
                </div>

                @if (calibration.id != null) {
                <div fxFlex>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.status.label' | translate }}</mat-label>
                    <mat-select name="idStatus" [(ngModel)]="calibration.idStatus" disabled>
                      @for (item of statuses; track item) {
                      <mat-option [value]="item.id">
                        {{ 'calibrationStatus.' + item.translation | translate }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                }

                @if (calibration.currentVersion > 0 && calibration.currentVersion != null) {
                <div fxFlex>
                  <div fxLayout="row">
                    <div fxFlex="50">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'calibrateEquipmentEdit.general.currentVersion.label' | translate }}</mat-label>
                        <input matInput name="currentVersion" [ngModel]="calibration.currentVersion" disabled>
                      </mat-form-field>
                    </div>
                    <div fxFlex="50">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'calibrateEquipmentEdit.general.signedVersion.label' | translate }}</mat-label>
                        <input matInput name="signedVersion" [ngModel]="calibration.signedVersion" disabled>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                }

              </div>

            </div>

            @if (equipment.id != null) {
            <div fxFlex="33" fxFlex.lt-md="100%">
              <div fxLayout="column" class="flexwrap">
                <div fxFlex>
                  <mat-form-field style="width: 95%;">
                    <mat-label>{{ 'calibrateEquipmentEdit.client.name.label' | translate }}</mat-label>
                    <input matInput name="clientName" [value]="clientName" disabled>
                  </mat-form-field>
                </div>
                <div fxFlex>
                  <mat-label>{{ 'calibrateEquipmentEdit.client.address.label' | translate }}</mat-label>
                  <textarea matInput [value]="clientAddress" name="clientAddress" style="resize: none;"
                    disabled> </textarea>
                </div>
              </div>
            </div>
            }

          </div>

        </mat-card-content>
      </mat-card>

      <mat-card class="card">
        <mat-card-content>
          <mat-toolbar color="secondary">
            {{ 'particlesEquipmentEdit.generalConditions.title' | translate }}
          </mat-toolbar>

          <div fxLayout="row wrap" fxLayoutGap="16px" class="flexwrap">

            <!-- Lugar de calibración -->
            <div fxFlex="30%" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'calibrateEquipmentEdit.calibrationData.place.label' | translate }}</mat-label>
                <mat-select required name="idPlace" [(ngModel)]="calibration.idPlace" [disabled]="isEditable()">
                  @for (item of places; track item) {
                  <mat-option [value]="item.id">
                    {{ 'calibrationPlace.' + item.translation | translate }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Estado de recepción -->
            <div fxFlex="30%" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'calibrateEquipmentEdit.calibrationData.reception.label' | translate }}</mat-label>
                <mat-select required name="idReception" [(ngModel)]="calibration.idReception" [disabled]="isEditable()">
                  @for (item of receptionStatus; track item) {
                  <mat-option [value]="item.id">
                    {{ 'calibrationReception.' + item.translation | translate }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Procedimiento de calibración -->
            <div fxFlex="30%" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'particlesEquipmentEdit.calibrationData.procedure.label' | translate }}</mat-label>
                <mat-select required name="idProcedure" [(ngModel)]="calibration.idProcedure" [disabled]="isEditable()">
                  @for (item of procedures; track item) {
                  <mat-option [value]="item.id">
                    {{ item.name }} ({{ item.description }})
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Caudal nominal -->
            <div fxFlex="18%" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'particlesEquipmentEdit.environmentalConditions.nomCaudal.label' | translate
                  }}</mat-label>
                <input matInput required type="number" name="flowRate" [(ngModel)]="calibration.flowRate"
                  [disabled]="isEditable()">
              </mat-form-field>
            </div>

            <!-- Número de canales -->
            <div fxFlex="18%" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'particlesEquipmentEdit.environmentalConditions.nChanel.label' | translate }}</mat-label>
                <input matInput required type="number" name="nchannel" [(ngModel)]="calibration.nchannel">
              </mat-form-field>
            </div>

            <!-- Temperatura -->
            <div fxFlex="18%" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'calibrateEquipmentEdit.environmentalConditions.temperature.label' | translate
                  }}</mat-label>
                <input matInput name="temperature" [(ngModel)]="calibration.temperature" [disabled]="isEditable()">
              </mat-form-field>
            </div>

            <!-- Humedad -->
            <div fxFlex="18%" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'calibrateEquipmentEdit.environmentalConditions.humidity.label' | translate }}</mat-label>
                <input matInput name="humidity" [(ngModel)]="calibration.humidity" [disabled]="isEditable()">
              </mat-form-field>
            </div>

            <!-- Presión -->
            <div fxFlex="18%" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'calibrateEquipmentEdit.environmentalConditions.pressure.label' | translate }}</mat-label>
                <input matInput name="pressure" [(ngModel)]="calibration.pressure" [disabled]="isEditable()">
              </mat-form-field>
            </div>

          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="card">
        <mat-card-content>

          <mat-toolbar color="secondary">
            {{ 'calibrateEquipmentEdit.pattern.title' | translate }}
            @if (!isEditable()) {
            <button mat-icon-button color="accent" (click)="newPatternRow()">
              <mat-icon>add</mat-icon>
            </button>
            }
          </mat-toolbar>

          <br />

          <div fxLayout="row">
            <div fxFlex fxFlex.lt-md="100%">
              <table mat-table matSort [dataSource]="dataSource" style="width: 95%;">

                <!-- Nombre -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'particlesPattern.dialog.equipment.name.label' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let pattern"> {{ pattern.equipment?.name }} </td>
                </ng-container>

                <!-- Fabricante -->
                <ng-container matColumnDef="maker">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'particlesPattern.dialog.equipment.maker.label' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let pattern"> {{ pattern.equipment?.maker }} </td>
                </ng-container>

                <!-- Modelo -->
                <ng-container matColumnDef="model">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'particlesPattern.dialog.equipment.model.label' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let pattern"> {{ pattern.equipment?.model }} </td>
                </ng-container>

                <!-- Número de Serie -->
                <ng-container matColumnDef="serialNum">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'particlesPattern.dialog.equipment.serialNum.label' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let pattern"> {{ pattern.equipment?.serialNum }} </td>
                </ng-container>

                <!-- Equipo -->
                <ng-container matColumnDef="equipment">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'particlesPattern.dialog.equipment.equipment.label' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let pattern"> {{ pattern.equipment?.equipment }} </td>
                </ng-container>

                <!-- Fecha de expiración-->
                <ng-container matColumnDef="expirationDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'particlesPattern.dialog.equipment.expirationDate.label' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let pattern"> {{ getDateExpiration(pattern) | fixDate}} </td>
                </ng-container>

                <!-- Editar -->
                <ng-container matColumnDef="edit">
                  <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
                  <td mat-cell *matCellDef="let pattern; let i = index">
                    @if (!isEditable()) {
                    <button mat-icon-button (click)="editPatternRow(i)">
                      <mat-icon>mode_edit</mat-icon>
                    </button>
                    }
                  </td>
                </ng-container>

                <!-- Eliminar -->
                <ng-container matColumnDef="delete">
                  <th mat-header-cell *matHeaderCellDef> {{ 'button.delete' | translate }} </th>
                  <td mat-cell *matCellDef="let pattern; let i = index">
                    @if (!isEditable()) {
                    <button mat-icon-button (click)="deletePatternRow(i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                    }
                  </td>
                </ng-container>

                <!-- Filas -->
                <tr mat-header-row *matHeaderRowDef="patternCols"></tr>
                <tr mat-row *matRowDef="let row; columns: patternCols;"></tr>

              </table>
            </div>
          </div>

        </mat-card-content>
      </mat-card>

      <mat-card class="card">
        <mat-card-content>
          <div fxLayout="row wrap" fxLayoutGap="24px">
            <!-- Ensayos precalibración -->
            <div fxFlex="48" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>
                  {{ 'calibrateEquipmentEdit.calibrationData.variables.asFound.label' | translate }}
                </mat-label>
                <mat-select multiple name="testsAsFound" [(value)]="selectedTestsAf" [disabled]="isEditable()">
                  @for (item of testTypesAf; track item) {
                  <mat-option [value]="item" (onSelectionChange)="onChangeAsFoundCheck($event)">
                    {{ 'particleTestType.' + item.translation | translate }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Ensayos postcalibración -->
            <div fxFlex="48" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>
                  {{ 'calibrateEquipmentEdit.calibrationData.variables.asLeft.label' | translate }}
                </mat-label>
                <mat-select multiple name="testsAsLeft" [(value)]="selectedTestsAl" [compareWith]="compareById"
                  [disabled]="isEditable()">
                  @for (item of testTypesAl; track item) {
                  <mat-option [value]="item" (onSelectionChange)="onChangeAsLeftCheck($event)">
                    {{ 'particleTestType.' + item.translation | translate }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>


          <mat-toolbar color="secondary">
            {{ 'particlesCalibration.tests.asfound.title' | translate }}
          </mat-toolbar>

          <mat-accordion>
            @for (test of testsAf; track test; let testIndex = $index) {
            <mat-expansion-panel class="overflowX" (afterExpand)="testTab = testIndex" (closed)="testTab = null">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div fxLayout="row">
                    <span [class]="checkAccording(test)">
                      {{getTestName(test.idTestType)}}
                    </span>
                  </div>
                  <!-- EDITAR TEST -->
                  <button mat-icon-button color="accent" (click)="openDialogEditTest(testIndex, test.type)">
                    <mat-icon style="font-size: 20px;">mode_edit</mat-icon>
                  </button>
                </mat-panel-title>

              </mat-expansion-panel-header>
              <div fxFlex="100" fxLayout="column">
                @for (result of test.results; track result; let i = $index) {
                <div fxFlex="100">
                  <!-- Nominal -->
                  @if (showNominal(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.nominal.label' | translate }}</mat-label>
                      <input matInput type="number" [ngModel]="result.nominal" name="nominal-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.nominal.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Canal -->
                  @if (showChannel(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.channel.label' | translate }}</mat-label>
                      <mat-select required name="idSize-{{testIndex}}{{i}}" [ngModel]="result.channelPha" disabled>
                        @for (item of particleSizes; track item) {
                        <mat-option [value]="item.size">
                          {{ item.size }}
                        </mat-option>
                        }
                      </mat-select>
                      <mat-error>
                        {{ 'particlesTest.dialog.test.channel.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Valor anterior -->
                  @if (showPreviousValue(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.previousValue.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.previousValue" name="previousValue-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.previousValue.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Cuentas observadas -->
                  @if (showObsAccounts(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.obs_account.label' | translate }}</mat-label>
                      <input matInput type="number" [ngModel]="result.obsAccount" name="obs_account-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.obs_account.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Tamaño certificado -->
                  @if (showSizeCertificate(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.cert_size.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.certSize" name="cert_size-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.cert_size.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Resolución obtenida (%) -->
                  @if (showObtResolucion(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.obt_resolution.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.obtResolution" name="obt_resolution-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.obt_resolution.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Tiempo del contador  -->
                  @if (showCountTime(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.count_time.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.countTime" name="count_time-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.count_time.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Tiempo del patrón  -->
                  @if (showStandarTime(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.standar_time.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.standarTime" name="standar_time-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.standar_time.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Mediana -->
                  @if (showMedian(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.median.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.median" name="median-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.median.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Valor ajustado -->
                  @if (showAjustedValue(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.ajustedValue.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.ajustedValue" name="ajustedValue-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.ajustedValue.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Ruido medido -->
                  @if (showMeasuredNoise(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.measuredNoise.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.noise" name="noise-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.measuredNoise.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Señal medida -->
                  @if (showMeasuredSignal(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.measuredSignal.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.signal" name="signal-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.measuredSignal.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Measured -->
                  @if (showMessuared(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.measured.label' | translate }}</mat-label>
                      <input matInput type="number " [ngModel]="result.measured" name="measured-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.measured.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Ensayo de eficiencia (%) -->
                  @if (showEfficiencyTest(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.efficiencyTest.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.efficiencyTest" name="efficiencytest-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.efficiencyTest.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Eficiencia obtenida (%) -->
                  @if (showObtainedEfficiency(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.obtainedEfficiency.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.obtainedEfficiency" name="obtainedEfficiency-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.obtainedEfficiency.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Tamaño partícula -->
                  @if (showSize(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.size.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.size" name="size-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.size.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Limit -->
                  @if (showLimit(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.limit.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.limit" name="limit-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.limit.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{'particlesTest.dialog.test.uncertainty.label' | translate }}</mat-label>
                      <input matInput type="number" [ngModel]="result.uncertainty" name="uncertainty-{{testIndex}}{{i}}" disabled>
                      <mat-error>
                        {{ 'particlesTest.dialog.test.uncertainty.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <!-- Result -->
                  @if (showResult(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{'particlesTest.dialog.test.result.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.result" name="result-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.result.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Pass -->
                  <div fxFlex="10" fxFlex.lt-md="100%">
                    <mat-checkbox matTooltip="{{ 'particlesTest.dialog.test.pass.label' | translate }}"
                      name="pass-{{testIndex}}{{i}}" [checked]="result.pass" disabled>
                      {{ 'particlesTest.dialog.test.pass.label' | translate }}
                    </mat-checkbox>
                  </div>
                  <!-- Fail -->
                  <div fxFlex="10" fxFlex.lt-md="100%">
                    <mat-checkbox matTooltip="{{ 'particlesTest.dialog.test.fail.label' | translate }}"
                      name="fail-{{testIndex}}{{i}}" [checked]="result.fail" disabled>
                      {{ 'particlesTest.dialog.test.fail.label' | translate }}
                    </mat-checkbox>
                  </div>
                </div>
                }
              </div>
              <br />
            </mat-expansion-panel>
            }
          </mat-accordion>
          <mat-toolbar color="secondary">
            {{ 'particlesCalibration.tests.asleft.title' | translate }}
          </mat-toolbar>
          <mat-accordion>
            @for (test of testsAl; track test; let testIndex = $index) {
            <mat-expansion-panel class="overflowX" (afterExpand)="testTab = testIndex" (closed)="testTab = null">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div fxLayout="row">
                    <span [class]="checkAccording(test)">
                      {{getTestName(test.idTestType)}}
                    </span>
                  </div>
                  <!-- EDITAR TEST -->
                  <button mat-icon-button color="accent" (click)="openDialogEditTest(testIndex,test.type)">
                    <mat-icon style="font-size: 20px;">mode_edit</mat-icon>
                  </button>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div fxFlex="100" fxLayout="column">
                @for (result of test.results; track result; let i = $index) {
                <div fxFlex="100">
                  <!-- Nominal -->
                  @if (showNominal(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.nominal.label' | translate }}</mat-label>
                      <input matInput type="number" [ngModel]="result.nominal" name="nominal-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.nominal.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Canal -->
                  @if (showChannel(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.channel.label' | translate }}</mat-label>
                      <mat-select required name="idSize-{{testIndex}}{{i}}" [ngModel]="result.channelPha" disabled>
                        @for (item of particleSizes; track item) {
                        <mat-option [value]="item.size">
                          {{ item.size }}
                        </mat-option>
                        }
                      </mat-select>
                      <mat-error>
                        {{ 'particlesTest.dialog.test.channel.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Valor anterior -->
                  @if (showPreviousValue(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.previousValue.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.previousValue" name="previousValue-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.previousValue.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Cuentas observadas -->
                  @if (showObsAccounts(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.obs_account.label' | translate }}</mat-label>
                      <input matInput type="number" [ngModel]="result.obsAccount" name="obs_account-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.obs_account.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Tamaño certificado -->
                  @if (showSizeCertificate(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.cert_size.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.certSize" name="cert_size-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.cert_size.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Resolución obtenida (%) -->
                  @if (showObtResolucion(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.obt_resolution.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.obtResolution" name="obt_resolution-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.obt_resolution.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Tiempo del contador  -->
                  @if (showCountTime(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.count_time.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.countTime" name="count_time-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.count_time.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Tiempo del patrón  -->
                  @if (showStandarTime(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.standar_time.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.standarTime" name="standar_time-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.standar_time.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Mediana -->
                  @if (showMedian(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.median.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.median" name="median-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.median.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Valor ajustado -->
                  @if (showAjustedValue(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.ajustedValue.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.ajustedValue" name="ajustedValue-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.ajustedValue.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Ruido medido -->
                  @if (showMeasuredNoise(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.measuredNoise.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.noise" name="noise-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.measuredNoise.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Señal medida -->
                  @if (showMeasuredSignal(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.measuredSignal.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.signal" name="signal-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.measuredSignal.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Measured -->
                  @if (showMessuared(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.measured.label' | translate }}</mat-label>
                      <input matInput type="number " [ngModel]="result.measured" name="measured-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.measured.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Ensayo de eficiencia (%) -->
                  @if (showEfficiencyTest(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.efficiencyTest.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.efficiencyTest" name="efficiencytest-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.efficiencyTest.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Eficiencia obtenida (%) -->
                  @if (showObtainedEfficiency(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.obtainedEfficiency.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.obtainedEfficiency" name="obtainedEfficiency-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.obtainedEfficiency.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Tamaño partícula -->
                  @if (showSize(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.size.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.size" name="size-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.size.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Limit -->
                  @if (showLimit(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{ 'particlesTest.dialog.test.limit.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.limit" name="limit-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.limit.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{'particlesTest.dialog.test.uncertainty.label' | translate }}</mat-label>
                      <input matInput type="number" [ngModel]="result.uncertainty" name="uncertainty-{{testIndex}}{{i}}" disabled>
                      <mat-error>
                        {{ 'particlesTest.dialog.test.uncertainty.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <!-- Result -->
                  @if (showResult(test)) {
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario" appearance="fill">
                      <mat-label>{{'particlesTest.dialog.test.result.label' | translate }}</mat-label>
                      <input matInput [ngModel]="result.result" name="result-{{testIndex}}{{i}}" disabled />
                      <mat-error>
                        {{ 'particlesTest.dialog.test.result.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  }
                  <!-- Pass -->
                  <div fxFlex="10" fxFlex.lt-md="100%">
                    <mat-checkbox matTooltip="{{ 'particlesTest.dialog.test.pass.label' | translate }}"
                      name="pass-{{testIndex}}{{indexResult}}" [checked]="result.pass" disabled>
                      {{ 'particlesTest.dialog.test.pass.label' | translate }}
                    </mat-checkbox>
                  </div>
                  <!-- Fail -->
                  <div fxFlex="10" fxFlex.lt-md="100%">
                    <mat-checkbox matTooltip="{{ 'particlesTest.dialog.test.fail.label' | translate }}"
                      name="fail-{{testIndex}}{{indexResult}}" [checked]="result.fail" disabled>
                      {{ 'particlesTest.dialog.test.fail.label' | translate }}
                    </mat-checkbox>
                  </div>
                </div>
                }
              </div>
            </mat-expansion-panel>
            }
          </mat-accordion>
        </mat-card-content>
      </mat-card>
      <mat-card class="card">
        <mat-card-content>
          <mat-toolbar color="secondary">
            {{ 'calibrateEquipmentEdit.observations.title' | translate }}
          </mat-toolbar>

          <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

            <div fxFlex="100" fxFlex.lt-md="100%">
              <mat-label>{{ 'calibrateEquipmentEdit.observations.label' | translate }}</mat-label>
              <textarea matInput [(ngModel)]="calibration.observations" name="observations" rows="5"
                style="resize: none;">
              </textarea>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="card">
        <mat-card-actions>
          <div fxFlex></div>
          @if (showRevertSign()) {
          <button mat-raised-button color="primary" (click)="revertSign()">
            {{ 'button.revertSign' | translate }} </button>
          }
          @if (showBack()) {
          <div fxFlex="0.5"></div>
          <button mat-raised-button color="primary" (click)="calculateBack()">
            {{ 'button.retreat' | translate }}</button>
          }
          @if (userCanModify()) {
          <div fxFlex="0.5"></div>
          <button mat-raised-button color="primary" (click)="saveCalibration()">
            {{ 'button.save' | translate }}</button>
          }
          @if (showAdvance()) {
          <div fxFlex="0.5"></div>
          <button mat-raised-button color="primary" (click)="calculateAdvance()">
            {{ 'button.advance' | translate }}</button>
          }
          @if (showManualSign()) {
          <div fxFlex="0.5"></div>
          <button mat-raised-button color="primary" (click)="manualSign()">
            {{ 'button.sign-manual' | translate }}</button>
          }
          @if (showAutomaticSign()) {
          <div fxFlex="0.5"></div>
          <button mat-raised-button color="primary" (click)="automaticSign()">
            {{ 'button.sign-automatic' | translate }}</button>
          }
          @if (showDownloadButton()) {
          <div fxFlex="0.5"></div>
          <button mat-raised-button color="accent" (click)="downloadPdf()">
            {{ 'button.download-certificate' | translate }}</button>
          }
          @if (showInvalidate()) {
          <div fxFlex="0.5"></div>
          <button mat-raised-button color="primary" (click)="invalidate()">
            {{ 'button.invalidate' | translate }}</button>
          }
          <div fxFlex="0.5"></div>
          <button mat-raised-button color="secondary" (click)="cancel()">{{ 'button.cancel' | translate }}</button>
        </mat-card-actions>
      </mat-card>

    </form>

  </mat-tab>
  @if (calibration.id != null) {
  <mat-tab label="{{ 'calibrateEquipmentEdit.historical.title' | translate }}">
    <app-particles-edit-audit [idCalibration]="calibration.id" [documentCode]="calibration.certificateNum"
      [calibration]="calibration" [equipment]="equipment">
    </app-particles-edit-audit>
  </mat-tab>
  }
</mat-tab-group>